import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const ZOOM_SIGNATURE_PATH = `${ORIENTATION_API_PREFIX}/zoom/signature`;

export const ZoomRole = { Participant: 0, Host: 1 } as const;
export type ZoomRole = (typeof ZoomRole)[keyof typeof ZoomRole];

const zoomRoleSchema = z.literal([ZoomRole.Participant, ZoomRole.Host]);

export const zoomSignatureRequestSchema = z.strictObject({
  sessionId: z.string().regex(UUID_REGEX),
  role: zoomRoleSchema,
});
export type ZoomSignatureRequest = z.infer<typeof zoomSignatureRequestSchema>;

// `sessionName` is the `tpc` claim, which `client.join()` must repeat exactly.
export const zoomSignatureResponseSchema = z.object({
  signature: z.string().min(1),
  sdkKey: z.string().min(1),
  sessionName: z.string().regex(UUID_REGEX),
  userName: z.string().min(1),
  role: zoomRoleSchema,
});
export type ZoomSignatureResponse = z.infer<typeof zoomSignatureResponseSchema>;
